var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"switch",class:{ active : _vm.switchState },on:{"click":function($event){_vm.switchStatus()}}},[_c('div',{staticClass:"indicator"})])}
var staticRenderFns = []

export { render, staticRenderFns }